import o from "./OrderTypeIcon.mjs";
import "../../../jsx-runtime-c20f6c15.mjs";
import "react";
import "@ancon/wildcat-types";
import "clsx";
import "../../../shared/icons/delivery-outline.svg.mjs";
import "../../../shared/icons/delivery-fill.svg.mjs";
import "../../../shared/icons/paper-bag-outline.svg.mjs";
import "../../../shared/icons/takeaway-fill.svg.mjs";
import "../../../shared/icons/table-order-outline.svg.mjs";
import "../../../shared/icons/eat-in-outline.svg.mjs";
import "../../../shared/icons/eat-in-fill.svg.mjs";
import "../../../shared/icons/box-pickup-order-outline.svg.mjs";
export {
  o as default
};
